import { render, staticRenderFns } from "./Workdays.vue?vue&type=template&id=b4cb5508&scoped=true&"
import script from "./Workdays.vue?vue&type=script&lang=js&"
export * from "./Workdays.vue?vue&type=script&lang=js&"
import style0 from "./Workdays.vue?vue&type=style&index=0&id=b4cb5508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb5508",
  null
  
)

export default component.exports